// extracted by mini-css-extract-plugin
export default {"frAttachmentContainer":"style_frAttachmentContainer__Dy4SS","label":"style_label__cNRRM","attachmentIcon":"style_attachmentIcon__AxSud","button":"style_button__o45oe"};